export default "__VITE_ASSET__C7otT5km__"